module.exports = __webpack_public_path__ + "static/media/internet-explorer-brands.e9b6353c.svg";